import Link from "next/link";

export default function SectionTitleComp({
  title,
  link,
  linkLabel,
}: {
  title: string;
  link?: string;
  linkLabel?: string;
}) {
  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="font-semibold text-dark text-xl lg:text-2xl">{title}</h1>
        {link && linkLabel && (
          <Link href={link} className="hidden lg:block">
            <span className="link-button">{linkLabel}</span>
          </Link>
        )}
      </div>
      <div className="title-under-line"></div>
    </div>
  );
}
